import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Button, Divider, Menu, Spin, Tabs, Typography } from 'antd';
import ReadDataTable from '../../Common/ReadDataTable';
import ActionHeader from '../../Common/ActionHeader';
import DeleteWarningModal from '../../Common/DeleteWarningModal';
import '../../Common/Form.css';
import SubunitEdit from '../SubunitEdit';
import SubunitAssetEdit from '../SubunitAssetEdit';
import { getSubunitWithAsset } from '../../../services/subunitService';
import { getSubunitKind } from '../SubunitHelpers';

const { Title } = Typography;

const SUPPORTED_SUBUNIT_TYPE = ['Video', 'Exercise', 'Certificate'];

const SubunitPage = (props) => {
  const [subunit, setSubunit] = useState({});
  const [subunitType, setSubunitType] = useState(null);
  const [formattedData, setFormattedData] = useState({});
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [subunitAsset, setSubunitAsset] = useState({});
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isEditAssetModalVisible, setIsEditAssetModalVisible] = useState(
    false
  );
  const [
    isDeleteAssetModalVisible,
    setIsDeleteAssetModalVisible
  ] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState({
    error: false,
    message: ''
  });

  const formatData = (data) => {
    const subunitTypeLocal = getSubunitKind(data);
    setSubunitType(subunitTypeLocal);
    return {
      subunitType: subunitTypeLocal,
      general: [
        {
          label: 'Title:',
          text: data.title ? data.title : ''
        },
        {
          label: 'Code:',
          text: data.code
        },
        {
          label: 'Section Number:',
          text: data.sectionNumber
        },
        {
          label: 'Type of Subunit:',
          text: subunitTypeLocal
        }
      ]
    };
  };

  const renderVideo = () => {
    let table = [
      { label: 'duration', text: subunitAsset.video.duration },
      { label: 'hlsLink', text: subunitAsset.video.hlsLink },
      { label: 'link', text: subunitAsset.video.link },
      { label: 'thumbnailLink', text: subunitAsset.video.thumbnailLink },
      {
        label: 'subtitles',
        text: `${subunitAsset.video.subtitles?.length}`
      }
    ];

    return <ReadDataTable items={table} />;
  };
  const renderVideoSubunitDetails = () => {
    let table = [{ label: 'topics', text: subunit.topics?.length }];

    return <ReadDataTable items={table} />;
  };

  const renderExercise = () => {
    let table = [
      { label: 'duration', text: subunitAsset.exercise.duration },
      { label: 'description', text: subunitAsset.exercise.description },
      { label: 'title', text: subunitAsset.exercise.title },
      {
        label: 'file  name',
        text: subunitAsset.exercise.file.name
      },
      {
        label: 'file  link',
        text: subunitAsset.exercise.file.link
      },
      { label: 'ctaBtnText', text: subunitAsset.exercise.ctaBtnText },
      { label: 'ctaBtnIcon', text: subunitAsset.exercise.ctaBtnIcon },
      {
        label: 'what type of exercise?',
        text: subunitAsset.exercise?.category
      }
    ];

    return <ReadDataTable items={table} />;
  };

  const renderExerciseSubunitDetails = () => {
    let table = [
      { label: 'icon', text: subunit.icon },
      { label: 'longDescription', text: subunit.longDescription }
    ];

    return <ReadDataTable items={table} />;
  };

  const renderCertificate = () => {
    let table = [
      { label: 'Title:', text: subunitAsset.certificate.title },
      {
        label: 'Criteria Wise Response:',
        text: `${
          subunitAsset.certificate.criteriaWiseResponse
            ? 'Criteria Wise Response Set (View in DB)'
            : 'Criteria Wise Response not Set (Set in DB)'
        }`
      },
      {
        label: 'Criteria:',
        text: `${
          subunitAsset.certificate.criteria
            ? 'Criteria Set (View in DB)'
            : 'Criteria not Set (Set in DB)'
        }`
      },
      {
        label: 'Mobile Image',
        text: subunitAsset.certificate?.imgData?.mobileImgData?.src
      },
      {
        label: 'Desktop Image',
        text: subunitAsset.certificate?.imgData?.desktopImgData?.src
      }
    ];

    return <ReadDataTable items={table} />;
  };

  const renderAssignment = () => {
    let table = [
      { label: 'Title:', text: subunitAsset.assignment.title },
      {
        label: 'longDescription',
        text: subunitAsset.assignment?.longDescription
      },
      {
        label: 'deadlineText',
        text: subunitAsset.assignment.deadlineText
      }
    ];

    return <ReadDataTable items={table} />;
  };

  const actionMenuSubunit = (
    <Menu>
      <Menu.Item onClick={() => setIsEditModalVisible(true)}>
        Edit Subunit
      </Menu.Item>
      <Menu.Item onClick={() => setIsDeleteModalVisible(true)}>
        Delete
      </Menu.Item>
    </Menu>
  );
  const actionMenuSubunitAsset = (
    <Menu>
      <Menu.Item onClick={() => setIsEditAssetModalVisible(true)}>
        Edit Subunit Asset
      </Menu.Item>
      <Menu.Item onClick={() => setIsDeleteAssetModalVisible(true)}>
        Delete
      </Menu.Item>
    </Menu>
  );

  const getData = () => {
    setIsLoading(true);
    getSubunitWithAsset({ code: props.match.params.subunitId })
      .then((response) => {
        if (response.length !== 0) {
          const subunit = response.subunit;
          const asset = response.asset;
          const data = formatData(subunit);
          setSubunit(subunit);
          setSubunitAsset(asset);
          setFormattedData(data);
        } else {
          throw Error('This course offer does not exist!');
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err}`
        });
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, [props.match.params.subunitId]);

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            textAlign: 'center',
            marginTop: '50px'
          }}>
          <Spin />
        </div>
      ) : status.error ? (
        <div style={{ marginTop: '50px', textAlign: 'center' }}>
          <Title>{status.message}</Title>
        </div>
      ) : (
        <>
          <DeleteWarningModal
            isVisible={isDeleteModalVisible}
            setIsVisible={setIsDeleteModalVisible}
            deleteLink={`${process.env.REACT_APP_BACKEND_URL}/`}
            params={{}}
          />
          <SubunitEdit
            isOpen={isEditModalVisible}
            subunitType={subunitType}
            toggle={() => setIsEditModalVisible(false)}
            subunit={subunit}
          />
          {SUPPORTED_SUBUNIT_TYPE.includes(subunitType) ? (
            <SubunitAssetEdit
              isOpen={isEditAssetModalVisible}
              subunitType={subunitType}
              toggle={() => setIsEditAssetModalVisible(false)}
              subunitAsset={subunitAsset}
            />
          ) : null}

          <ActionHeader
            title={`${formattedData.subunitType}: ${subunit.code}  `}
            actionMenu={actionMenuSubunit}
          />
          {formattedData.general ? (
            <section className="grey-section">
              <Title level={5}>Details</Title>
              <ReadDataTable items={formattedData.general} />
              {subunit.videoId ? (
                <div>
                  <Title level={5}>Video Subunit Details</Title>
                  {renderVideoSubunitDetails()}
                </div>
              ) : null}
              {subunit.exerciseId ? (
                <div>
                  <Title level={5}>Exercise Subunit Details</Title>
                  {renderExerciseSubunitDetails()}
                </div>
              ) : null}

              <Divider />

              <Divider />

              {subunit.videoId && subunitAsset ? (
                <div>
                  <ActionHeader
                    title={`Video Identifer: ${subunit.videoId}  `}
                    actionMenu={actionMenuSubunitAsset}
                  />
                  <Divider />
                  <Title level={5}>Video Details</Title>
                  {renderVideo()}
                </div>
              ) : null}
              {subunit.exerciseId && subunitAsset ? (
                <div>
                  <ActionHeader
                    title={`Exercise identifer: ${subunit.exerciseId}  `}
                    actionMenu={actionMenuSubunitAsset}
                  />
                  <Divider />
                  <Title level={5}>Exercise Details</Title>
                  {renderExercise()}
                </div>
              ) : null}

              {subunit.certificateId && subunitAsset ? (
                <div>
                  <ActionHeader
                    title={`Certificate identifer: ${subunit.certificateId}  `}
                    actionMenu={actionMenuSubunitAsset}
                  />
                  <Divider />
                  <Title level={5}> Certificate Details</Title>
                  {renderCertificate()}
                </div>
              ) : null}

              {subunit.assignmentId && subunitAsset ? (
                <div>
                  <Title level={5}>Assignment Details</Title>
                  {renderAssignment()}
                </div>
              ) : null}
            </section>
          ) : null}
        </>
      )}
    </div>
  );
};

export default withRouter(SubunitPage);
